import React from 'react';
import { connect } from 'react-redux';
import MiniCart from '../Components/MiniCart';

const PdfFolderContainer = props => <MiniCart {...props} icon={'download-folder'} label='header__documents_label' />

const mapStateToProps = state => {
    const { pdfFolder } = state;
    return {
        ...pdfFolder,
    }
}

export default connect(mapStateToProps)(PdfFolderContainer);